module.exports = __webpack_public_path__ + "static/carlsbad-12-8a65601565890ac8ad089021ea7364c5.png";